<template>
	<div class="quote-container mb-20">
		<div class="quote-header" id="secondary-desktop-element">
			<div class="quote-header-container">
				<div class="pmb-image">
					<a href="/" class="">
						<img :src="baseUrl + '/images/bikesure-logo-primary.png'" alt="Protect my bike" class="" />
					</a>
				</div>
				<div class="numbers-container">
					<div class="numbers-content">
						<div class="numbers"
							:class="{ 'current': index == currStepNo, 'active': index <= currStepNo, 'has_line': index > 0 }"
							v-for="(step, index) in steps">
							<div class="number-container">
								<div class="number">
									<div class="number-circle" v-if="index <= currStepNo">
										{{ (index + 1) }}
									</div>
								</div>
								<div class="step-name">
									<p class="desktop" v-if="step.title">{{ step.title | prettify }}</p>
									<p class="desktop" v-else>{{ step.name | prettify }}</p>
									<p class="mobile">{{ step.number }}</p>
								</div>
							</div>
						</div>
					</div>
					<div class="lines">
						<div class="line" :step="step" :stepname="step.name"
							:class="{ 'showable': index > 0, 'showing': (lineProgress + 1) >= step }"
							v-for="(step, index) in (stepTotal)">
						</div>
					</div>
				</div>

				<div class="pricing-box-container">
					<div class="pricing-box">
						<div class="pricing-container">
							<dl>
								<dt class="pricing-title">
									Price <span class="ipt">(inc IPT)</span>
								</dt>
								<dd class="pricing-value">
									<span v-if="!isLoading">{{ annualPremium | currency }}</span>
									<span v-else>
										<span class="hidden sm:block">&nbsp;</span>
										<span class="block sm:hidden text-gray-400 text-lg">Loading...</span>
									</span>
								</dd>
								<dd class="monthly-value">
									<span v-if="!isLoading">
										or {{ monthlyPremium | currency }}/month
									</span>
									<span v-else>&nbsp;</span>
								</dd>
							</dl>
							<div class="hidden sm:block">
								<loading variant="mini" :show="isLoading"></loading>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="boxes">
				<div class="box" v-for="(step, index) in steps" :class="{ 'complete': (step.number <= currStepNo + 1) }">

				</div>
			</div>


		</div>


		<div class="content-container">



			<div class="content-padding"></div>
			<div class="section-container ">

				<div class="w-full rounded-md flex gap-2 items-center ml-auto justify-end mb-2 -mt-16 md:-mt-20">

					<div>
						<img src="/images/awards-2024-white.png" class="h-12 md:h-20" alt="">
					</div>

					<img src="/images/feefo.png" class="h-12 md:h-20" alt="">
				</div>

				<div class="errors ">
					<tw-alert v-for="(f, key) in feedback" :key="'feedback_' + key" :type="f.type"
						:show="feedback.length > 0" class="mb-3">
						{{ f.message }}
					</tw-alert>
				</div>


				<div class="section-container-child">
					<!-- <keep-alive> -->
					<router-view v-if='quote' :quote="quote && quote.quote ? quote.quote : null" :loading="isLoading"
						@feedback="showFeedback" @price="updatePrice" @refresh="refresh" @loading="uploadLoading"
						@hide-footer="handleHideFooter" ref="section" @next="goToNextStep" :payment-loading='paymentLoading'
						@paymentLoading='setPaymentLoading'></router-view>

					<!-- </keep-alive> -->
					<div class="buttons-container mb-2"
						v-if="hideFooter == false && (!isLoading && paymentLoading == false && steps[currStepNo].has_buttons)">
						<div class="button-container left-btn">
							<button class="button secondary expand" v-if="prevStepName" @click="prev">Back</button>
						</div>
						<div class="button-container right-btn">
							<button class="button expand" :disabled="!steps[currStepNo].passed" v-if="steps[nextStepNo]"
								@click="next">{{ (steps[currStepNo].nextTitle) ? steps[currStepNo].nextTitle : 'Next'
								}}</button>
							<button class="button expand" :disabled="!steps[currStepNo].passed || purchaseLoading" v-else>{{
								(purchaseLoading) ? 'Loading...' : 'Purchase Policy' }}</button>
						</div>
					</div>

				</div>
			</div>
			<div class="content-padding"></div>

		</div>
	</div>
</template>

<script>
export default {
	name: 'quote.form',
	props: ['setting'],
	data() {
		return {
			hideFooter: false,
			currStepNo: 0,
			steps: [
				{
					name: 'cover',
					passed: false,
					has_buttons: true,
					number: 1,
				},
				{
					name: 'contact',
					title: 'contact',
					passed: false,
					has_buttons: true,
					number: 2,
				},
				{
					name: 'declaration',
					passed: false,
					has_buttons: true,
					number: 3,
				},
				{
					name: 'payment',
					passed: false,
					nextTitle: 'Pay now',
					has_buttons: true,
					number: 4,
				},
				{
					name: 'confirm',
					passed: false,
					has_buttons: false,
					number: 5,
				}
			],
			numSteps: 5,
			isLoading: false,
			isEmailLoading: false,
			purchaseLoading: false,
			quote: null,
			feedback: [],
			details: false,
			policyPrice: 0,
			paymentLoading: false,
		}
	},
	watch: {
		$route(to, from) {
			// ensures if back button is pressed the currStepNo is correct
			var pieces = to.name.split(".");
			let name = pieces[1];

			this.steps.forEach((s, i) => {
				if (s.name == name) {
					this.currStepNo = i;
				}
			});
		}
	},
	computed: {
		nextStepNo() {
			return (this.currStepNo + 1);
		},
		stepTotal() {
			return (this.steps.length) * 2;
		},
		currStepName() {
			return this.steps[this.currStepNo].name;
		},
		lineProgress() {
			return (this.steps[this.currStepNo].number * 2) - 2;
		},
		nextStepName() {
			var next = false;

			if (this.steps[this.currStepNo + 1]) {
				next = this.steps[this.currStepNo + 1].name;
			}

			return next;
		},
		prevStepName() {
			var previous = false;

			if (this.steps[this.currStepNo - 1]) {
				previous = this.steps[this.currStepNo - 1].name;
			}

			return previous;
		},
		urlPart() {
			var urlParts = window.location.pathname.split("/");

			return urlParts[urlParts.length - 1];
		},
		annualPremium() {
			var premium = 0;

			if (this.quote) {
				premium = this.quote.quote.client_premium;
			}

			if (this.policyPrice) {
				premium = this.policyPrice;
			}

			return premium;
		},
		monthlyPremium() {
			return (this.annualPremium / 12);
		}
	},
	mounted() {

		const self = this;
		self.steps.forEach((s, i) => {
			if (s.name == self.urlPart) {
				self.currStepNo = i;
			}
		});

		// Get Quote
		this.getQuote();

		// Get details need in Quote process
		this.getDetails();
	},
	methods: {
		goToNextStep() {
			// redirect to next step
			this.$router.push({ name: 'quote.' + this.nextStepName });

			// increase step number
			this.currStepNo++;

			// scroll to top page
			this.scrollToTop();
		},
		next() {
			// if submit method exists on section, run it
			if (typeof this.$refs.section.submit !== "undefined") {
				this.$refs.section.submit();
			} else {
				this.goToNextStep();
			}

		},
		prev() {
			// redirect to previous step
			this.$router.push({ name: 'quote.' + this.prevStepName });

			// decrease step number
			this.currStepNo--;

			// check if step has passed
			this.steps[this.currStepNo].passed = this.$refs['section'].isComplete;

			// scroll to top of page
			this.scrollToTop();
		},
		scrollToTop() {
			window.scrollTo(0, 0);
		},
		getQuote() {

			const self = this;


			self.isLoading = true;

			Vue.axios.get('quote/getQuote')
				.then((resp) => {

					self.isLoading = false;

					if (resp.data) {
						if (!resp.data.success) {
							self.quote = null;

							if (!self.quote) {
								window.location.replace("/");
							}
						} else {
							self.quote = resp.data;

							let allowed = ['quote.cover', 'quote.contact'];

							if (resp.data.quote.policy_id && resp.data.quote.status == 'sale') {
								if (this.$route.name !== 'quote.confirm') {
									self.currStepNo = 4;
									self.$router.push({ name: 'quote.confirm' });
								}
							}
						}
					} else {

						self.feedback.push({
							'type': 'error',
							'message': 'An error occurred - Quote couldn\'t be found'
						});
					}
				})
				.catch(error => {
					self.isLoading = false;

					self.feedback.push({
						'type': 'error',
						'message': error
					});
				});

		},
		emailQuote() {
			const self = this;

			self.isEmailLoading = true;

			// add new bike to quote
			axios.get('quote/email')
				.then((resp) => {
					if (resp.data) {
						self.feedback.push({
							'type': 'success',
							'message': 'A copy of the quote has been sent to you'
						});

						self.isEmailLoading = false;
					}
				})
				.catch(error => {
					self.isEmailLoading = false;

					// show feedback
					self.feedback.push({
						'type': 'error',
						'message': error
					});
				});
		},
		showFeedback(e) {
			const self = this;

			self.feedback.push({
				'type': e.type,
				'message': e.message
			});

			// remove message after so long
			setTimeout(function () {
				self.feedback = [];
			}, 4000);
		},
		updatePrice(e) {
			if (this.policyPrice != e) {
				this.policyPrice = e;
			}
		},
		refresh(e) {
			if (e.quote) {
				this.quote.quote = e.quote;
			}

			let passed = false
			if (e.passed) {
				passed = e.passed;
			}
			this.steps[this.currStepNo].passed = passed;
		},
		uploadLoading(e) {
			this.isLoading = e;
		},
		setPaymentLoading(isLoading) {
			this.paymentLoading = isLoading;
		},
		getDetails() {
			const self = this;

			Vue.axios.get('quote/details')
				.then((resp) => {
					if (resp.data) {
						self.details = resp.data;
					}
				});
		},
		handleHideFooter(value) {
			this.hideFooter = value;
		}
	}
}
</script>